import { makeStyles } from '@material-ui/core';

export const styles = makeStyles((theme) => ({
    resultContainer: {
        position: 'relative',
        // maxWidth: '735px',
        maxHeight: '200px',
        overflow: 'auto',
        marginBottom: '15px',
        padding: '0 5px',
        boxShadow: '0 2px 14px 0 rgba(0, 0, 0, 0.06)',
        borderRadius: '6px',
        '&::-webkit-scrollbar': {
            width: '5px'
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#063f5e'
        }
    },
    resultItem: {
        display: 'flex',
        justifyContent: 'space-between',
        flexFlow: 'wrap',
        // gridTemplateColumns: '200px 2fr 1fr',
        // gridGap: '10px',
        alignItems: 'center',
        padding: '16px 13px',
        borderBottom: '1px solid #e8e8e8',
        '& img': {
            padding: '0 5px'
        },
        '&:last-child': {
            borderBottom: 'none'
        }
    },
    overallInfo: {
        display: 'flex',
        flexFlow: 'row-reverse',
        justifyContent: 'center',
        marginInlineStart: '8px',
        '& div': {
            whiteSpace: 'nowrap'
        }
    },
    loadingContainer: {
        minHeight: '55px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    progressRoot: {
        height: '23px !important',
        width: '23px !important'
    },
    linkWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        flex: '1 1 30%',
        [theme.breakpoints.down(1025)]: {
            margin: '0 auto',
            paddingTop: '14px',
            flex: '1 1 100%',
            justifyContent: 'center'
        },
        '& svg': {
            width: '15px',
            height: '15px'
        }
    },
    row: {
        display: 'flex',
        alignItems: 'center',
        flexFlow: 'wrap',
        flex: '1 1 34%',
        [theme.breakpoints.down(1025)]: {
            flex: '1 1 48%'
        }
    },
    text: {
        fontSize: '13px',
        fontWeigh: 'bold',
        color: '#509ffa',
        marginInlineStart: '8px'
    },
    tagsContainer: {
        display: 'flex',
        alignItems: 'center',
        flexFlow: 'wrap',
        width: '200px',
        [theme.breakpoints.down(1025)]: {
            justifyContent: 'flex-end'
        }
    },
    tag: {
        background: '#e7ecf2',
        borderRadius: '4px',
        padding: '4px 8px',
        fontSize: '12px',
        marginInlineEnd: '6px',
        marginTop: '6px'
    },
    patientLoading: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        height: '24px',
        flex: '1 1 30%',
        '& div': {
            width: '24px !important',
            height: '100% !important',
            marginInlineEnd: '60px'
        },
        [theme.breakpoints.down(1025)]: {
            flex: '1 1 100%',
            justifyContent: 'center',
            '& div': {
                marginInlineEnd: '0px'
            }
        }
    },
    tooltip: {
        background: '#ebf0ff',
        color: 'black',
        fontSize: '13px',
        boxShadow: '0 2px 4px 0 rgba(84, 94, 102, 0.12)',
        width: '190px',
        padding: '12px',
        textAlign: 'start',
        unicodeBidi: 'plaintext'
    },
    arrow: {
        color: '#ebf0ff',
        left: '50%',
        right: '50%'
    }
}));
